import { usePostHog } from "@/analytics/usePostHog";
import { ArrowUpRight, MapPinned } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { antalyaHubPath } from "@/data/antalyaLocations";

interface AntalyaLocationCalloutProps {
  articleSlug: string;
}

export const AntalyaLocationCallout = ({
  articleSlug,
}: AntalyaLocationCalloutProps) => {
  const { t, i18n } = useTranslation("locations");
  const posthog = usePostHog();

  return (
    <aside
      data-service-callout="antalya-locations"
      className="mt-8 border-y border-border py-7"
    >
      <div className="flex items-start gap-4">
        <MapPinned
          className="mt-1 h-6 w-6 shrink-0 text-primary"
          aria-hidden="true"
        />
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.14em] text-primary">
            {t("articleCallout.eyebrow")}
          </p>
          <h2 className="mt-2 text-xl font-semibold text-foreground">
            {t("articleCallout.title")}
          </h2>
          <p className="mt-2 leading-7 text-muted-foreground">
            {t("articleCallout.description")}
          </p>
          <Link
            to={antalyaHubPath(i18n.language)}
            className="mt-4 inline-flex min-h-11 items-center gap-2 font-semibold text-primary underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            onClick={() =>
              posthog?.capture("article_location_guide_clicked", {
                article_slug: articleSlug,
                city: "antalya",
                locale: i18n.language,
              })
            }
          >
            {t("articleCallout.link")}
            <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </aside>
  );
};
